import React from "react";
import { createRoot } from "react-dom/client";
import Routes from "@/routes";
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from '@/theme/theme';
import { AuthProvider } from '@/hooks/useAuth';
import { LanguageProvider } from '@/contexts/LanguageContext';
import { CartProvider } from '@/contexts/CartContext';

const root = createRoot(document.getElementById("root"));

root.render(
	// <React.StrictMode>
		<AuthProvider>
			<LanguageProvider>
				<ThemeProvider theme={theme}>
					<CssBaseline />
					<CartProvider>
						<Routes />
					</CartProvider>
				</ThemeProvider>
			</LanguageProvider>
		</AuthProvider>
	// </React.StrictMode>
);